// src/store/store.js
import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./modules/userSlice";
import creditsReducer from "./modules/creditsSlice";

const savedUser =
  typeof localStorage !== "undefined"
    ? JSON.parse(localStorage.getItem("user") || "null")
    : null;

export const store = configureStore({
  reducer: {
    user: userReducer,
    credits: creditsReducer,
  },
  preloadedState: {
    user: {
      currentUser: savedUser,
    },
  },
});

// Subscribe to store changes and save user to localStorage
store.subscribe(() => {
  if (typeof localStorage === "undefined") return;
  const state = store.getState();
  if (state.user?.currentUser) {
    // Get current saved user to preserve referralId if it exists
    const currentSavedUser = JSON.parse(localStorage.getItem("user") || "null");
    const currentUser = state.user.currentUser as any;
    const userToSave = {
      ...currentUser,
      // Preserve referralId from current state or from localStorage if it exists
      referralId: currentUser.referralId || currentSavedUser?.referralId,
    };
    localStorage.setItem("user", JSON.stringify(userToSave));
  } else {
    // Clear user from localStorage if logged out
    localStorage.removeItem("user");
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
